<main class="listagem">
    <div class="card card-default">
        <app-support-gridview [config]="config" (onReject)="deleteSellerOnVacation($event)"></app-support-gridview>
    </div>
</main>
